import htmlToPlaintext from '../functions/htmlToPlaintext'

function generateTitle (yItem) {
    const yTitle = yItem.get('title')
    const yDetails = yItem.get('details')

    if (yTitle && yTitle.toString() !== '') {
        return yTitle.toString()

    } else if (yDetails) {
        return htmlToPlaintext(
            yDetails.toString()
                .replace(/<\/?paragraph[^>]*\/?>/, ' ')
                .replace(/<\/?hard_break[^>]*\/?>/, ' ')
        )
    }

    return ''
}

const currentWatchers = new Map()

export function yItemTitleWatcher (yItem, callback) {

    if (!currentWatchers.has(yItem)) {
        const setItemTitle = _.debounce(() => {
            const currentWatcher = currentWatchers.get(yItem)
            const newTitle = generateTitle(yItem)

            for (const callback of currentWatcher.callback) {
                callback(newTitle)
            }
        }, 100)

        yItem.get('title').observe(setItemTitle)
        yItem.get('details').observeDeep(setItemTitle)

        currentWatchers.set(yItem, {
            setItemTitle,
            callback: [],
        })
    }

    const currentWatcher = currentWatchers.get(yItem)
    currentWatcher.callback.push(callback)
    callback(generateTitle(yItem))

    return () => {
        const currentWatcher = currentWatchers.get(yItem)
        const index = currentWatcher.callback.indexOf(callback)
        if (index !== -1) currentWatcher.callback.splice(index, 1)

        if (currentWatcher.callback.length === 0) {
            const { setItemTitle } = currentWatcher

            if (yItem.get('title')) {
                yItem.get('title').unobserve(setItemTitle)
            }

            if (yItem.get('details')) {
                yItem.get('details').unobserveDeep(setItemTitle)
            }

            setItemTitle.cancel()
            currentWatchers.delete(yItem)
        }
    }
}
